import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import TimelineIcon from '@mui/icons-material/Timeline';
import SettingsIcon from '@mui/icons-material/Settings';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Root,
  NoFilterData,
  FilterButtonContainerSiteManager,
  TabsSpacing
} from '#component/warehouse/site-manager/styles';
import FilterWrapper from '#component/general/list-filter/filter-wrapper';
import MobileDoubleButtons from '#component/general/mobile-double-buttons/mobile-double-buttons';
import MobileTabs from '#component/general/mobile-tabs/mobile-tabs';
import { fetchWarehousesAndAppliances } from '#action/warehouse/warehouses';
import MobileDrawerMenu from '#component/general/mobile-drawer-menu';
import DeleteWarehouseDialog from '#component/addressbook/dashboard/delete-addressbook-dialog';
import { deleteAppliance } from '#action/warehouse/appliance/appliance';
import { fetchAppliances } from '#action/warehouse/appliance/appliance-paginated';
import PreloaderComponent from '#component/preloader';
import AppliancesTabContent from './mobile-tabs/appliances-tab-content';
import filterConfig from './filter/config';

const ApplianceMobileView = ({
  appliances,
  applianceStatus,
  account,
  showAllId,
  applianceDevices,
  setShowAllId,
  handleApplianceClick,
  warehouses,
  isFilterSelected,
  page,
  pages,
  handlePageChange,
  userType,
  anchorEl,
  setAnchorEl,
  appliance
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isDeleteAppianceModalOpen, setIsDeleteAppianceModalOpen] = useState(false);
  const loading = applianceStatus !== 'succeeded' || applianceStatus === 'idle';

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchWarehousesAndAppliances(true));
    };

    fetchData();
  }, [dispatch]);

  const tabLabels = ['Appliances', 'Sites'];

  const handleApplianceMenuClose = () => {
    setAnchorEl(false);
  };

  const handleDeleteAppianceModalClose = () => {
    setIsDeleteAppianceModalOpen(false);
    setAnchorEl(null);
  };

  const handleDeleteAppliance = async () => {
    const result = await dispatch(deleteAppliance(appliance?.id));
    if (result?.success) {
      handleDeleteAppianceModalClose();
      dispatch(fetchAppliances());
    }
  };

  const handleAppianceTimelineClick = () => history.push(`/warehouse/appliance-overview/${appliance?.id}`);
  const handleAppianceSettingsClick = () => history.push(`/warehouse/appliance/edit/${appliance?.id}`);
  const handleAppianceAuditClick = () => history.push(`/warehouse-log?appliance=${appliance?.id}`);
  const handleDeleteApplianceClick = () => setIsDeleteAppianceModalOpen(true);

  const applianceMenuItems = [
    { name: 'Timeline', onClick: handleAppianceTimelineClick, icon: <TimelineIcon /> },
    { name: 'Settings', onClick: handleAppianceSettingsClick, icon: <SettingsIcon /> },
    { name: 'Audit trail', onClick: handleAppianceAuditClick, icon: <SpeakerNotesIcon /> },
    { name: 'Delete', onClick: handleDeleteApplianceClick, icon: <DeleteIcon /> }
  ];

  const handleTabChange = tabName => {
    if (tabName === 1) {
      history.push('/warehouse-manager');
    }
  };

  const tabContents = [
    <AppliancesTabContent
      appliances={appliances}
      applianceStatus={applianceStatus}
      account={account}
      showAllId={showAllId}
      applianceDevices={applianceDevices}
      setShowAllId={setShowAllId}
      handleApplianceClick={handleApplianceClick}
      warehouses={warehouses}
      isFilterSelected={isFilterSelected}
      loading={loading}
      pages={pages}
      page={page}
      handlePageChange={handlePageChange}
    />,
    <>null</>
  ];

  const SectionWrapper = !isFilterSelected && !loading ? NoFilterData : Root;

  return (
    <SectionWrapper as="section">
      <FilterButtonContainerSiteManager>
        <FilterWrapper data={filterConfig} />
      </FilterButtonContainerSiteManager>
      {loading ? (
        <PreloaderComponent />
      ) : (
        <>
          <TabsSpacing style={loading ? { display: 'none' } : {}}>
            <MobileTabs
              labels={tabLabels}
              contents={tabContents}
              setMobileChosenTab={handleTabChange}
            />
          </TabsSpacing>
          <MobileDrawerMenu
            isOpen={anchorEl}
            onClose={handleApplianceMenuClose}
            menuTitle="test"
            menuItems={applianceMenuItems}
          />
          <DeleteWarehouseDialog
            open={isDeleteAppianceModalOpen}
            dialogTitle={`Do you want to delete the "${appliance?.label ?? ''}"?`}
            entityTitle={appliance?.label ?? ''}
            dialogContentText="Type the application label to confirm"
            textFieldLabel="Label"
            onClose={handleDeleteAppianceModalClose}
            onDelete={handleDeleteAppliance}
          />
          {userType < 10 &&
            <MobileDoubleButtons
              firstLabel="Add site"
              secondLabel="Add application"
              firstAddress="/create-warehouse"
              secondAddress="/warehouse/appliance/create"
            />}
        </>
      )}
    </SectionWrapper>
  );
};

export default ApplianceMobileView;
